<template>
  <div class="dropdown is-active">
    <div class="dropdown-menu">
      <div class="dropdown-content max-h-[300px] overflow-y-auto">
        <template v-if="items.length">
          <a
            v-for="(item, index) in items"
            :key="index"
            class="dropdown-item"
            :class="{ 'bg-gray-100 !text-black': index === selected_index }"
            @click="selectItem(index)"
          >
            {{ item.label }}
          </a>
        </template>
        <template v-else>
          <span class="dropdown-item">
            {{ i18n.global.t('select.actions.noResults') }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import i18n from '@/i18n/index';

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },

  command: {
    type: Function,
    required: true,
  },
});

const selected_index = ref(0);

watch(
  () => props.items,
  () => {
    selected_index.value = 0;
  },
);

function selectItem(index) {
  const item = props.items[index];

  if (item) {
    props.command({ label: item.label, id: item.id });
  }
}

function upHandler() {
  selected_index.value = (selected_index.value + props.items.length - 1) % props.items.length;
}

function downHandler() {
  selected_index.value = (selected_index.value + 1) % props.items.length;
}

function enterHandler() {
  selectItem(selected_index.value);
}

function onKeyDown({ event }) {
  if (event.key === 'ArrowUp') {
    upHandler();
    return true;
  }

  if (event.key === 'ArrowDown') {
    downHandler();
    return true;
  }

  if (event.key === 'Enter' || event.key === 'Tab') {
    enterHandler();
    return true;
  }

  return false;
}

defineExpose({ onKeyDown });
</script>
